"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resourceNames = exports.resources = void 0;
exports.resources = [
    { name: 'energy', icon: 'energy' },
    { name: 'stone', icon: 'stone' },
    { name: 'iron-ore', icon: 'iron-ore' },
    { name: 'iron', icon: 'iron' },
    { name: 'copper-ore', icon: 'copper-ore' },
    { name: 'copper', icon: 'copper' },
    { name: 'gold-ore', icon: 'gold-ore' },
    { name: 'gold', icon: 'gold' },
    { name: 'water', icon: 'water' },
    { name: 'sulfur', icon: 'sulfur' },
    { name: 'sulfuric-acid', icon: 'sulfuric-acid' },
    { name: 'silicon', icon: 'silica' },
    { name: 'quartz', icon: 'quartz' },
    { name: 'petrol', icon: 'packaged-oil' },
    { name: 'coal', icon: 'coal' },
    { name: 'graphite', icon: 'compacted-coal' },
    { name: 'graphene', icon: 'glass-foundation-8m-x-1m' },
    { name: 'plastic', icon: 'plastic' },
];
exports.resourceNames = exports.resources.map(r => r.name);



//////////////////
// WEBPACK FOOTER
// ../engine/dist/config/resources.js
// module id = LY2/
// module chunks = 0